(function () {
  function renderAlpineComponent() {
    if (!window?.Alpine) return;
    window.Alpine.data("mainProductGallery", () => ({
      swiperInstance: null,
      init() {
        this.initializeSwiper();
        window.addEventListener("collection_changed", () => {
          setTimeout(() => {
            this.initializeSwiper();
          }, 100);
        });
      },

      initializeSwiper() {
        // Destroy existing swiper instance if it exists
        if (this.swiperInstance) {
          this.destroy();
        }

        const swiper = this.$refs.slider;
        if (!swiper) return;

        // Initialize new swiper instance
        this.swiperInstance = new Swiper(swiper, {
          autoplay: {
            delay: 4000,
            pauseOnMouseEnter: true,
          },
          breakpoints: {
            0: { slidesPerView: 1.5, spaceBetween: 20 },
            768: { slidesPerView: 2, spaceBetween: 10 },
          },
          speed: 800,
          /*           touchRatio: 0,
          allowTouchMove: false, */
          loop: true,
          navigation: false,
          centeredSlides: true,
          on: {
            init: (e) => {
              setTimeout(() => {
                e.slides[e.activeIndex].classList.add("kf-swiper-slide-active");
              }, 100);
            },
          },
        });

        this.swiperInstance.on("realIndexChange", (e) => {
          e.slides.forEach((s) => s.classList.remove("kf-swiper-slide-active"));
          e.slides[e.activeIndex].classList.add("kf-swiper-slide-active");
          /*           setTimeout(() => {
            e.slides[e.activeIndex].classList.remove("kf-swiper-slide-active");
          }, 4300); */
        });
      },

      destroy() {
        if (!this.swiperInstance) return;
        this.removeActiveClasses();
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      },
      removeActiveClasses() {
        const main_product_gallery = document.querySelector(".main-product-gallery");
        if (!main_product_gallery) return;
        const slides = main_product_gallery.querySelectorAll(".swiper-slide");
        if (!slides) return;
        slides.forEach((s) => s.classList.remove("kf-swiper-slide-active"));
      },
    }));
  }

  document.addEventListener("alpine:init", renderAlpineComponent);
  renderAlpineComponent();
})();
